import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useSignupData } from '../signup-data/useSignupData';
import { Data } from 'signup-constants/signupData/Data';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { Step } from 'signup-constants/Step';
import { useTracker } from '../tracking/useTracker';
import { useEffect, useState } from 'react';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { na1 } from 'hubspot-url-utils/hublets-next';
import { jsx as _jsx } from "react/jsx-runtime";
const HubletLocation = () => {
  const {
    data: hublet
  } = useSignupData(Data.HubletSelection);
  const {
    currentStep
  } = useCurrentStep();
  const flowConfig = getFlowConfig();
  const Tracker = useTracker();
  const shouldShow = currentStep !== Step.HubletSelection && flowConfig.shouldShowHubletLocationText && hublet;
  const [hasTracked, setHasTracked] = useState(false);
  useEffect(() => {
    if (shouldShow && !hasTracked) {
      Tracker.signupInteraction('viewed-hublet-location-text', {
        selectedOption: hublet || na1
      });
      setHasTracked(true);
    }
  }, [shouldShow, Tracker, hasTracked, hublet]);
  const i18nKey = isValidI18nKey(`legal.dataHostedIn.${hublet}`) ? `legal.dataHostedIn.${hublet}` : 'legal.dataHostedIn.na1';
  if (!shouldShow) {
    return null;
  }
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    "data-test-id": `hublet-location-text-${hublet}`,
    message: i18nKey
  });
};
export default HubletLocation;